// ABOUTME: GSAP-based animations for rich-text sections. Uses SplitText when available, custom split as fallback.
// ABOUTME: Depends on GSAP, ScrollTrigger, and optionally SplitText/TextPlugin loaded in theme.liquid.

(function () {
  var initialized = false;

  function run() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return false;
    if (initialized) return true;

    gsap.registerPlugin(ScrollTrigger);
    if (typeof SplitText !== 'undefined') gsap.registerPlugin(SplitText);
    if (typeof TextPlugin !== 'undefined') gsap.registerPlugin(TextPlugin);

    var TRIGGER_START = 'top 88%';
    var ENTER_DELAY = 1;
    var SPLIT_DURATION = 1;
    var BLOCK_DURATION = 1;
    var STAGGER_CHARS = 0.018;
    var STAGGER_WORDS = 0.03;
    var STAGGER_LIMIT = 32;
    var Y_CHARS = 16;
    var Y_WORDS = 12;
    var Y_BLOCK = 20;

    function scrollTriggerVars(trigger, onKill) {
      var vars = {
        trigger: trigger,
        start: TRIGGER_START,
        once: true
      };
      if (onKill) vars.onKill = onKill;
      return vars;
    }

    function customSplit(el, mode) {
      var text = el.textContent.trim();
      if (!text) return [];
      el.textContent = '';
      var tokens = mode === 'chars' ? text.split('') : text.split(/\s+/);
      var frag = document.createDocumentFragment();
      var spans = [];
      for (var i = 0; i < tokens.length; i++) {
        var span = document.createElement('span');
        span.className = 'rich-text__split-item';
        span.style.display = 'inline-block';
        span.style.overflow = 'hidden';
        if (mode === 'chars') {
          span.textContent = tokens[i] === ' ' ? '\u00A0' : tokens[i];
        } else {
          span.textContent = tokens[i];
          if (i < tokens.length - 1) span.appendChild(document.createTextNode('\u00A0'));
        }
        frag.appendChild(span);
        spans.push(span);
      }
      el.appendChild(frag);
      return spans;
    }

    function runSplitAnimation(el, type) {
      var isChars = type === 'chars';
      var mode = isChars ? 'chars' : 'words';
      var targets;
      var split;
      var revert = function () {
        if (split && typeof split.revert === 'function') split.revert();
        if (el._splitInstance) el._splitInstance = null;
      };

      if (typeof SplitText !== 'undefined') {
        if (el._splitInstance) el._splitInstance.revert();
        split = SplitText.create(el, { type: mode, smartWrap: isChars });
        el._splitInstance = split;
        targets = isChars ? split.chars : split.words;
      } else {
        targets = customSplit(el, type);
      }

      if (!targets || targets.length === 0) return;

      var yFrom = isChars ? Y_CHARS : Y_WORDS;
      var staggerVal = isChars ? STAGGER_CHARS : STAGGER_WORDS;

      gsap.fromTo(targets, { opacity: 0, y: yFrom, force3D: true }, {
        opacity: 1,
        y: 0,
        duration: SPLIT_DURATION,
        delay: ENTER_DELAY,
        stagger: { each: staggerVal, limit: STAGGER_LIMIT },
        ease: 'power2.out',
        force3D: true,
        scrollTrigger: scrollTriggerVars(el, typeof SplitText !== 'undefined' ? revert : undefined)
      });
    }

    function runBlockAnimation(el, type, triggerEl) {
      var trigger = triggerEl || el;
      var fromVars = { opacity: 0, force3D: true };
      if (type === 'fade-up') fromVars.y = Y_BLOCK;
      else if (type === 'fade-down') fromVars.y = -Y_BLOCK;
      else if (type === 'scale') fromVars.scale = 0.96;

      var tl = gsap.timeline({
        scrollTrigger: scrollTriggerVars(trigger)
      });
      tl.fromTo(el, fromVars, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: BLOCK_DURATION,
        ease: 'power2.out',
        force3D: true
      }, ENTER_DELAY);
    }

    function hasRichContent(el) {
      return el.classList.contains('rich-text__content') || el.querySelector('p, a, strong, em');
    }

    function runAnimation(el, type) {
      if (!type || type === 'none') return;

      var isSplit = type === 'words' || type === 'chars';
      var richContent = hasRichContent(el);
      var canSplit = isSplit && !richContent && el.childNodes.length <= 1;

      if (canSplit) {
        runSplitAnimation(el, type);
      } else {
        var blockType = (richContent && isSplit) ? 'fade-up' : type;
        var trigger = richContent ? (el.closest('section') || el) : null;
        runBlockAnimation(el, blockType, trigger);
      }
    }

    function init() {
      gsap.utils.toArray('[data-rich-text-animate]').forEach(function (el) {
        var type = (el.getAttribute('data-rich-text-animate') || 'none').trim();
        runAnimation(el, type);
      });
      ScrollTrigger.refresh();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
        initialized = true;
      });
    } else {
      init();
      initialized = true;
    }
    return true;
  }

  function tryRun() {
    if (run()) return;
    var attempts = 0;
    var maxAttempts = 80;
    var interval = setInterval(function () {
      attempts++;
      if (run()) {
        clearInterval(interval);
        return;
      }
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 50);
  }

  tryRun();

  setTimeout(function () {
    document.body.classList.add('rich-text-animations-ready');
  }, 2000);

  document.addEventListener('shopify:section:load', function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    initialized = false;
    tryRun();
  });
})();
